import React, { Component } from 'react';
import {observer} from 'mobx-react'
import styles from './index.css';
import SimpleLineIcon from 'react-simple-line-icons';
import EquipMenu from '../../components/EquipComponents/EquipMenu/index';
import ChooseRegion from '../../components/EquipComponents/ChooseRegion/index'
import ChooseEquip from '../../components/EquipComponents/ChooseEquip/index';
import ChooseCropPlan from '../../components/EquipComponents/ChooseCropPlan/index'
import ChooseDifficulty from '../../components/EquipComponents/ChooseDifficulty/index'
import EquipResults from "../../components/EquipComponents/EquipResults/index";
import {presets} from '../../stores/index';

@observer
export default class somethingElse extends Component {
  state = {stage:'region'};
    componentWillMount(){
        document.querySelector("html").style.fontSize = (window.innerWidth)/120 + 'px'
        document.body.onresize = (e)=>{
            document.querySelector("html").style.fontSize = (e.target.innerWidth)/120 + 'px'
        }
    }
    render() {
        const input = presets.inputEquip.findIndex((item)=>item.quantity);
        const output = presets.outputEquip.findIndex((item)=>item.quantity);
        const cleaning = presets.cleaningEquip.findIndex((item)=>item.quantity);
        const drying = presets.dryingEquip.findIndex((item)=>item.quantity);
        const storage = presets.storageEquip.findIndex((item)=>item.quantity);

        return (
            <div className={styles.elevatorBuildUp} style={{height:window.innerHeight}}>
              <EquipMenu/>
              <div className={styles.elevatorBuildupStageContainer}>
                <div className={styles.equipStagesList}>
                  <div className={styles.equipStagesHeading}>КОНСТРУКТОР ЕЛЕВАТОРУ</div>
                    <div>
                        <div>
                            <div>
                                <span><h2 style={{fontWeight:300}}>НАЗВА ЕЛЕВАТОРУ:</h2></span>
                                <span className={styles.inputContainer}>
                                    <input name="text" type="text" onChange={(e)=>{presets.setElevatorsName(e.target.value)}} placeholder="Elevator name #1" />
                                </span>
                            </div>
                        </div>
                    </div>
                  <div className={styles.equipStagesStage + ((this.state.stage === 'region') ? " " + styles.activeTab : '')} onClick={() => {
                    this.setState({stage: 'region'})
                  }}>
                    <div className={styles.itemIcon + (presets.region ? ' ' + styles.active : '')} >
                      <SimpleLineIcon name={presets.region ? 'check' : 'plus'}  style={{fontSize: '1.25rem'}} />
                    </div>
                    <h3>РЕГІОН РОЗМІЩЕННЯ</h3>
                  </div>
                  <div className={styles.equipStagesStage + ((
                        this.state.stage === 'inputEquip' ||
                        this.state.stage === 'cleaningEquip' ||
                        this.state.stage === 'dryingEquip' ||
                        this.state.stage === 'storageEquip' ||
                        this.state.stage === 'outputEquip'
                      ) ? ' ' + styles.activeTab : '')}>
                    <div className={styles.itemIcon + ((input === -1 || output === -1 || cleaning === -1 || drying === -1 || storage === -1) ? "" : ' ' + styles.active)} >
                      <SimpleLineIcon name={(input === -1 || output === -1 || cleaning === -1 || drying === -1 || storage === -1) ? 'plus' : 'check'} style={{fontSize: '1.25rem'}} />
                    </div>
                    <h3>ЕЛЕМЕНТИ ЕЛЕВАТОРУ</h3>
                    <div className={styles.itemIcon + ' ' + styles.dropdownArrow} >
                      <SimpleLineIcon name="arrow-down"  style={{fontSize: '1.25rem'}} />
                    </div>
                    <div className={styles.equipStagesStageDropdown}>
                      <div className={styles.equipStagesItem + ((this.state.stage === 'inputEquip') ? " " + styles.active : '')} onClick={() => {
                        this.setState({stage: 'inputEquip'})
                      }}>
                        <div className={styles.itemIcon + (input === -1 ?  "" : ' ' + styles.active)} >
                          <SimpleLineIcon name={input === -1 ?  "plus" : "check"}  style={{fontSize: '1.25rem'}} />
                        </div>
                        <h4>Приймання</h4>
                      </div>
                      <div className={styles.equipStagesItem + ((this.state.stage === 'cleaningEquip') ? " " + styles.active : '')}  onClick={() => {
                        this.setState({stage: 'cleaningEquip'})
                      }}>
                        <div className={styles.itemIcon  + (cleaning === -1 ?  "" : ' ' + styles.active)} >
                          <SimpleLineIcon name={cleaning === -1 ?  "plus" : "check"}   style={{fontSize: '1.25rem'}} />
                        </div>
                        <h4>Очистка</h4>
                      </div>
                      <div className={styles.equipStagesItem + ((this.state.stage === 'dryingEquip') ? " " + styles.active : '')} onClick={() => {
                        this.setState({stage: 'dryingEquip'})
                      }}>
                        <div className={styles.itemIcon  + (drying === -1 ?  "" : ' ' + styles.active)} >
                          <SimpleLineIcon name={drying === -1 ?  "plus" : "check"}   style={{fontSize: '1.25rem'}} />
                        </div>
                        <h4>Сушка</h4>
                      </div>
                      <div className={styles.equipStagesItem + ((this.state.stage === 'storageEquip') ? " " + styles.active : '')} onClick={() => {
                        this.setState({stage: 'storageEquip'})
                      }}>
                        <div className={styles.itemIcon  + (storage === -1 ?  "" : ' ' + styles.active)} >
                          <SimpleLineIcon name={storage === -1 ?  "plus" : "check"}   style={{fontSize: '1.25rem'}} />
                        </div>
                        <h4>Зберігання</h4>
                      </div>
                      <div className={styles.equipStagesItem + ((this.state.stage === 'outputEquip') ? " " + styles.active : '')} onClick={() => {
                        this.setState({stage: 'outputEquip'})
                      }}>
                        <div className={styles.itemIcon  + (output === -1 ?  "" : ' ' + styles.active)} >
                          <SimpleLineIcon name={output === -1 ?  "plus" : "check"}  style={{fontSize: '1.25rem'}} />
                        </div>
                        <h4>Відгрузка</h4>
                      </div>
                    </div>
                  </div>
                  <div className={styles.equipStagesStage + ((this.state.stage === 'cropPlan') ? " " + styles.activeTab : '')} onClick={() => {
                    this.setState({stage: 'cropPlan'})
                  }}>
                    <div className={styles.itemIcon  + (storage === -1 || !presets.region ?  "" : ' ' + styles.active)} >
                      <SimpleLineIcon name={ storage === -1 || !presets.region  ?  "plus" : 'check'}  style={{fontSize: '1.25rem'}} />
                    </div>
                    <h3>ПЛАН ОБЕРТУ КУЛЬТУР</h3>
                  </div>
                  <div className={styles.equipStagesStage + ((this.state.stage === 'difficulty') ? " " + styles.activeTab : '')} onClick={() => {
                    this.setState({stage: 'difficulty'})
                  }}>
                    <div className={styles.itemIcon + ' ' + styles.active} >
                      <SimpleLineIcon name="check"  style={{fontSize: '1.25rem'}} />
                    </div>
                    <h3>РІВЕНЬ СКЛАДНОСТІ</h3>
                  </div>
                </div>

                <div className={styles.stage} >
                  {this.state.stage === 'region' &&
                    <ChooseRegion/>
                  }
                  {this.state.stage === 'inputEquip' &&
                  <ChooseEquip elem={this.state.stage}
                               limit = {6}
                               data={{
                                   title: "Вибір обладнання для приймання",
                                   desc:"Пропускна спроможність (тон/год)"
                               }}
                  />
                  }
                  {this.state.stage === 'dryingEquip' &&
                  <ChooseEquip elem={this.state.stage}
                               limit = {8}
                               data={{
                                   title:"Вибір обладнання для сушки" ,
                                   desc:"Эфективність сушки (%) \n Продуктивність (тон/год)"
                               }}
                  />
                  }
                  {this.state.stage === 'cleaningEquip' &&
                  <ChooseEquip elem={this.state.stage}
                               limit = {8}
                               data={{
                                   title: "Вибір обладнання для очистки",
                                   desc:"Эфективність очистки (%) \n Продуктивність (тон/год)"
                               }}
                  />
                  }
                  {this.state.stage === 'storageEquip' &&
                  <ChooseEquip elem={this.state.stage}
                               refer ={true}
                               limit = {12}
                               data={{
                                   title: "Вибір потужностей зберігання",
                                   desc:"Об'єм зберігання (т.)"
                               }}
                  />
                  }
                  {this.state.stage === 'outputEquip' &&
                  <ChooseEquip elem={this.state.stage}
                               limit = {6}
                               data={{
                                   title: "Вибір обладнання для відгрузки",
                                   desc:"Пропускна спроможність (тон/год)"
                               }}
                  />
                  }
                  {this.state.stage === 'cropPlan' &&
                    <ChooseCropPlan/>
                  }
                  {this.state.stage === 'difficulty' &&
                    <ChooseDifficulty/>
                  }
                </div>
                <EquipResults/>
              </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/shared/containers/ElevatorBuild/index.js